export var GlobalModalModes;
(function (GlobalModalModes) {
    GlobalModalModes["Edit"] = "edit";
    GlobalModalModes["Delete"] = "delete";
    GlobalModalModes["Success"] = "success";
})(GlobalModalModes || (GlobalModalModes = {}));
export var Statuses;
(function (Statuses) {
    Statuses["Enabled"] = "enabled";
    Statuses["Disabled"] = "disabled";
    Statuses["Pending"] = "pending";
})(Statuses || (Statuses = {}));
